import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NetworkingService } from '../networking.service';
import { API } from '../../data/api';
import { Clinic } from '../../data/models/Clinic';

@Injectable({
  providedIn: 'root'
})
export class ClinicService {

  constructor(private networkingService: NetworkingService) {}

  getClinicDetails(): Observable<Clinic> {
    return this.networkingService.getRequest<Clinic>(API.clinicDetails)
  }

  updateClinic(payload: any): Observable<Clinic> {
    return this.networkingService.putRequest(API.clinicUpdate, payload)
  }

  uploadLogo(file: File): Observable<any> {
    const formData = new FormData()
    formData.append('file', file)
    return this.networkingService.postRequest(API.clinicLogoUpload, formData)
  }
}
